import React from "react";
import './hedro.css';

export default function HeroSection() {
  const handleWhatsAppClick = () => {
    window.location.href = 'https://wa.me/qr/3UMFKPY76AACG1'; // Replace with your WhatsApp link
  };

  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <p className="section--title">Hey, I'm Said</p>
          <h1 className="hero--section--title">
            <span className="hero--section-title--color">BAKABOU</span>{" "}  
            
          </h1>
          <p className="hero--section-description">
            Experienced frontend-Backend developer with a passion for creating visually stunning and user-friendly websites.
            <br />
          </p>
        </div>
        <button className="btn btn-primary">Get In Touch</button>
        <button className="btn btn-primary" onClick={handleWhatsAppClick}>+212 671926562</button>
      </div>
      <div className="hero--section--img">
        <img src="./img/saadi.png" alt="saidbk" />
      </div>
    </section>
  );
}